var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.isDeleteView
      ? _c("div", [
          _vm.item.userCanRestore
            ? _c(
                "a",
                {
                  staticClass: "btn btn-default btn-block",
                  attrs: { href: _vm.restoreItemEndPoint },
                },
                [
                  _c("span", {
                    staticClass: "fa fa-undo",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" Restore item\n        "),
                ]
              )
            : _c(
                "a",
                {
                  staticClass:
                    "btn btn-default btn-block table-browser-is-disabled",
                  attrs: {
                    disabled: "",
                    "data-toggle": "tooltip",
                    "data-placement": "top",
                    title: "You do not have permission to restore this item",
                  },
                },
                [
                  _c("span", {
                    staticClass: "fa fa-undo",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" Restore item\n        "),
                ]
              ),
        ])
      : _c(
          "div",
          [
            _c(
              "modal",
              {
                model: {
                  value: _vm.revokeAccessModelOpened,
                  callback: function ($$v) {
                    _vm.revokeAccessModelOpened = $$v
                  },
                  expression: "revokeAccessModelOpened",
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "margin-left margin-right",
                    attrs: { slot: "title" },
                    slot: "title",
                  },
                  [
                    _c("em", [
                      _vm._v(
                        'Revoking additional access for "' +
                          _vm._s(_vm.item.name) +
                          '"'
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("api-errors", { attrs: { errors: _vm.errors } }),
                _vm._v(" "),
                _c("div", { staticClass: "alert alert-warning" }, [
                  _c("div", { staticClass: "word-break-all" }, [
                    _c("strong", [
                      _vm._v(
                        '\n                        You are about to revoke all additional access for "' +
                          _vm._s(_vm.item.name) +
                          '"\n                    '
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "margin-above" }, [
                    _vm._v(
                      '\n                    Click "Confirm" to proceed.\n                '
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  { attrs: { slot: "footer" }, slot: "footer" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-default",
                        attrs: { type: "button" },
                        on: { click: _vm.toggleRevokeAccessModel },
                      },
                      [
                        _c("span", {
                          staticClass: "fa fa-times",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" Cancel\n                    "),
                      ]
                    ),
                    _vm._v(" "),
                    _c("submit-button", {
                      attrs: {
                        text: "Confirm",
                        icon: "user-times",
                        type: "primary",
                        loading: _vm.isLoading,
                      },
                      on: { click: _vm.revokeAccess },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "modal",
              {
                model: {
                  value: _vm.removeFromWorkGroupModelOpened,
                  callback: function ($$v) {
                    _vm.removeFromWorkGroupModelOpened = $$v
                  },
                  expression: "removeFromWorkGroupModelOpened",
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "margin-left margin-right",
                    attrs: { slot: "title" },
                    slot: "title",
                  },
                  [
                    _c("em", [
                      _vm._v('Removing "' + _vm._s(_vm.item.name) + '"'),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("api-errors", { attrs: { errors: _vm.errors } }),
                _vm._v(" "),
                _c("div", { staticClass: "alert alert-warning" }, [
                  _c("div", { staticClass: "word-break-all" }, [
                    _c("strong", [
                      _vm._v(
                        '\n                        You are about to remove "' +
                          _vm._s(_vm.item.name) +
                          '" from "' +
                          _vm._s(_vm.extraInfo.workgroupName) +
                          '"\n                    '
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "margin-above" }, [
                    _vm._v(
                      '\n                    Click "Confirm" to proceed.\n                '
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  { attrs: { slot: "footer" }, slot: "footer" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-default",
                        attrs: { type: "button" },
                        on: { click: _vm.toggleRemoveFromWorkGroupModel },
                      },
                      [
                        _c("span", {
                          staticClass: "fa fa-times",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" Cancel\n                    "),
                      ]
                    ),
                    _vm._v(" "),
                    _c("submit-button", {
                      attrs: {
                        text: "Confirm",
                        icon: "chain-broken",
                        type: "primary",
                        loading: _vm.isLoading,
                      },
                      on: { click: _vm.removeFromWorkGroup },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.item.userCanEdit || _vm.item.userCanDelete
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-default",
                    attrs: { type: "button" },
                    on: { click: _vm.toggleDropdown },
                  },
                  [
                    _vm._v("\n            Item actions "),
                    _c("span", { staticClass: "caret" }),
                  ]
                )
              : _c(
                  "button",
                  {
                    staticClass: "btn btn-default table-browser-is-disabled",
                    attrs: {
                      type: "button",
                      disabled: "",
                      "data-toggle": "tooltip",
                      "data-placement": "top",
                      title:
                        "You do not have permission to perform any item actions",
                    },
                  },
                  [
                    _vm._v("\n            Item actions "),
                    _c("span", { staticClass: "caret" }),
                  ]
                ),
            _vm._v(" "),
            _c("transition", { attrs: { name: "table-browser-slide" } }, [
              _vm.dropDownOpened
                ? _c(
                    "ul",
                    { staticClass: "table-browser-dropdown-menu" },
                    [
                      _vm.extraInfo.assignedAccess
                        ? [
                            _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass: "btn btn-default btn-block",
                                  attrs: { href: _vm.changeAccessEndPoint },
                                },
                                [
                                  _c("span", {
                                    staticClass: "fa fa-user-edit",
                                    attrs: { "aria-hidden": "true" },
                                  }),
                                  _vm._v(
                                    " Change access role\n                        "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass: "btn btn-default btn-block",
                                  attrs: { href: _vm.revokeAccessEndPoint },
                                },
                                [
                                  _c("span", {
                                    staticClass: "fa fa-user-times",
                                    attrs: { "aria-hidden": "true" },
                                  }),
                                  _vm._v(
                                    " Revoke access role\n                        "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.item.userCanDelete
                        ? _c("li", [
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-default btn-block",
                                attrs: { href: _vm.deleteItemEndPoint },
                              },
                              [
                                _c("span", {
                                  staticClass: "glyphicon glyphicon-trash",
                                  attrs: { "aria-hidden": "true" },
                                }),
                                _vm._v(" Delete item\n                    "),
                              ]
                            ),
                          ])
                        : _c("li", [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn-default btn-block table-browser-is-disabled",
                                attrs: {
                                  disabled: "",
                                  "data-toggle": "tooltip",
                                  "data-placement": "top",
                                  title:
                                    "You do not have permission to delete this item",
                                },
                              },
                              [
                                _c("span", {
                                  staticClass: "glyphicon glyphicon-trash",
                                  attrs: { "aria-hidden": "true" },
                                }),
                                _vm._v(" Delete item\n                    "),
                              ]
                            ),
                          ]),
                      _vm._v(" "),
                      _vm.item.userCanEdit
                        ? [
                            _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass: "btn btn-default btn-block",
                                  attrs: { href: _vm.editItemEndPoint },
                                },
                                [
                                  _c("span", {
                                    staticClass: "fa fa-pencil",
                                    attrs: { "aria-hidden": "true" },
                                  }),
                                  _vm._v(
                                    " Edit item\n                        "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.isWorkgroupView
                              ? _c("li", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "btn btn-default btn-block",
                                      on: {
                                        click: _vm.toggleRevokeAccessModel,
                                      },
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "fa fa-user-times",
                                      }),
                                      _vm._v(
                                        " Revoke all additional access\n                        "
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isWorkgroupView
                              ? _c("li", [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "btn btn-default btn-block",
                                      on: {
                                        click:
                                          _vm.toggleRemoveFromWorkGroupModel,
                                      },
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "fa fa-chain-broken",
                                      }),
                                      _vm._v(
                                        " Remove from workgroup\n                        "
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        : [
                            _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "btn btn-default btn-block table-browser-is-disabled",
                                  attrs: {
                                    disabled: "",
                                    "data-toggle": "tooltip",
                                    "data-placement": "top",
                                    title:
                                      "You do not have permission to edit this item",
                                  },
                                },
                                [
                                  _c("span", { staticClass: "fa fa-pencil" }),
                                  _vm._v(
                                    " Edit item\n                        "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.isWorkgroupView
                              ? _c("li", [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-default btn-block table-browser-is-disabled",
                                      attrs: {
                                        disabled: "",
                                        "data-toggle": "tooltip",
                                        "data-placement": "top",
                                        title:
                                          "You do not have permission to revoke all additional access",
                                      },
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "fa fa-user-times",
                                      }),
                                      _vm._v(
                                        " Revoke all additional access\n                        "
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isWorkgroupView
                              ? _c("li", [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-default btn-block table-browser-is-disabled",
                                      attrs: {
                                        disabled: "",
                                        "data-toggle": "tooltip",
                                        "data-placement": "top",
                                        title:
                                          "You do not have permission to remove this item",
                                      },
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "fa fa-chain-broken",
                                      }),
                                      _vm._v(
                                        " Remove from workgroup\n                        "
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ],
                    ],
                    2
                  )
                : _vm._e(),
            ]),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }